import styled from "styled-components";

export const SectionWrapper = styled.div`
  position: relative;
`;
export const WavesWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  line-height: 0;
  transform: rotate(180deg);
  z-index: -1;
  > svg {
    position: relative;
    display: block;
    width: calc(300% + 1.3px);
    height: 500px;
    > path {
      fill: #2ccbd1;
    }
  }
`;
export const ArticlesGridWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 20px;
  min-height: 800px;
  margin: 0px 15px 125px 15px;
  @media (min-width: 600px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (min-width: 1000px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media (min-width: 1200px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
`;
export const ArticleLead = styled.div`
  font-family: "Prompt", sans-serif;
  font-weight: bold;
  color: #303030;
  padding-top: 70px;
  padding-left: 15px;
  > h4 {
    margin-top: 0;
  }
`;
export const ArticleSearch = styled.div`
  display: flex;
  margin: 0px 15px 25px 15px;
  align-items: center;
  height: 50px;
  > input {
    width: 100%;
    background-color: rgba(23, 23, 23, 1);
    color: #fff;
    padding: 15px;
    border: none;
    outline: none;
    flex: 1;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    height: 100%;
    box-sizing: border-box;
  }
  > button {
    display: inline-flex;
    border-radius: 0px;
    align-items: center;
    justify-content: center;
    background-color: rgba(23, 23, 23, 1);
    color: ${props => props.theme.colors.accentPurple};
    padding: 0 12px;
    cursor: pointer;
    height: 100%;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    margin: 0;
    border: none;
    -webkit-appearance: none;
    appearance: none;
    > span {
      > svg {
        height: 1.25em;
        width: 1.25em;
        display: block;
      }
    }
  }
`;
export const NoArticles = styled.div`
  position: relative;
  margin: 0px 15px;
`;
export const FloatingText = styled.div`
  position: absolute;
  top: 40px;
  left: 20px;
  > h2 {
    font-family: "Prompt", sans-serif;
    font-weight: 700;
    color: white;
    text-shadow: 1px 1px 2px black;
  }
`;
